import { css } from '@emotion/react'
import { colors, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

export const headerContainer = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #000000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  ${MQ.NOT_PHONES} {
    display: none;
  }
`

export const header = css`
  display: flex;
  align-items: center;
  padding: ${spacing(4)} ${spacing(2)};
  background-color: #000000;
  position: relative;
`

export const logoAndTitleContainer = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
`

export const logoImage = css`
  width: 24px;
  height: 24px;
  object-fit: contain;
`

export const title = css`
  color: ${colors.white100};
  margin: 0;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const tabsContainer = css`
  display: flex;
  padding: ${spacing(2)} ${spacing(2)};
  background-color: #000000;
`

export const tabsWrapper = css`
  display: flex;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: ${spacing(3)};
  padding: ${spacing(0.375)};
  gap: ${spacing(0.1875)};
  width: 100%;
`

export const tab = css`
  flex: 1;
  padding: ${spacing(1.125)} ${spacing(1.5)};
  background: transparent;
  border: none;
  border-radius: ${spacing(2.625)};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 33px;
  font-size: 12px;
  font-weight: 500;
  
  &:hover {
    color: rgba(255, 255, 255, 0.9);
  }
`

export const activeTab = css`
  background-color: #6FCF97 !important;
  
  &:hover {
    background-color: #6FCF97 !important;
  }
`

export const tabText = css`
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  font-weight: 500;
  text-align: center;
  transition: color 0.2s ease;
  font-size: 12px;
`

export const activeTabText = css`
  color: #1a1a1a !important;
  font-weight: 600;
` 